import React from "react";
import AdminLayout from "../layouts/AdminLayout";
import InstructorProfileView from "../components/manage-user/InstructorProfileView";

const InstructorProfile = () => {
  return (
    <AdminLayout>
      <InstructorProfileView />
    </AdminLayout>
  );
};

export default InstructorProfile;
